import createRoute         from '@widesk-ui/tools/createRoute';
import RelatedContentModel from '@models/shop/RelatedContentModel';

export default createRoute.dashboard('/related_contents', 'shop', 'RelatedContentDashboard', RelatedContentModel.localize());
